
import { useState, useEffect } from "react";
import { getAllCategories } from "@/services/categoryService";
import { Territory } from "@/types/supabase";
import { getTerritories } from "@/utils/supabase/areaHelpers";

/**
 * Custom hook to fetch metadata (categories, territories, suburbs) for the explore page
 */
export function useExploreMeta() {
  const [allCategories, setAllCategories] = useState<string[]>([]);
  const [allSuburbs, setAllSuburbs] = useState<string[]>([]);
  const [territories, setTerritories] = useState<Territory[]>([]);
  
  useEffect(() => {
    const fetchMetadata = async () => {
      try {
        // Fetch categories
        const categoriesData = await getAllCategories();
        setAllCategories(categoriesData);
        
        // Fetch territories using the utility function
        const territoriesData = await getTerritories();
        if (territoriesData) {
          setTerritories(territoriesData);
          const allSuburbs = territoriesData.flatMap(territory => territory.suburbs || []);
          setAllSuburbs(allSuburbs);
        }
      } catch (error) {
        console.error("Error fetching metadata:", error);
      }
    };
    
    fetchMetadata();
  }, []);

  return { allCategories, allSuburbs, territories };
}
